import { render, staticRenderFns } from "./boxCount.vue?vue&type=template&id=6eac75d4"
import script from "./boxCount.vue?vue&type=script&lang=js"
export * from "./boxCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports